import types from './InventoryItemEventType';

/**
 * Названия событий жизненного цикла. Зеркало App\Enums\InventoryItemEventTypeTitle.
 *
 * ЗАПАСНОЙ СЛОВАРЬ, А НЕ ОСНОВНОЙ. Название приезжает вместе с событием (поле label),
 * и лента берёт его оттуда: так новый тип, добавленный на бэкенде, читается и в уже
 * выкаченном фронте. Этот словарь нужен там, где события ещё нет, — подписи фильтров
 * и легенды, — и как последняя страховка, если label почему-то пуст.
 */
export default class InventoryItemEventTypeTitle {
    static [types.RECEIVED] = 'Принято к учёту';
    static [types.ISSUED] = 'Выдано';
    static [types.RETURNED] = 'Возвращено на склад';
    static [types.HOLDER_CHANGED] = 'Ответственный изменён';
    static [types.MOVED] = 'Перемещено';
    static [types.MARKED_BROKEN] = 'Обнаружена неисправность';
    static [types.FAULT_CLEARED] = 'Отметка о неисправности снята';
    static [types.REPAIR_SENT] = 'Отправлено в ремонт';
    static [types.REPAIR_RETURNED] = 'Возвращено из ремонта';
    static [types.WRITTEN_OFF] = 'Списано';
}
